import localStorageUtil from '@/common/localStorageUtil';
export default {
  markAsRead(item) {
    let dateIsoString = this.setUserdatemodified(item);
    console.log('readService.markAsRead', dateIsoString);
    item._userState = Object.assign(item._userState, { dateread: dateIsoString });

    localStorageUtil.addUserState(item);
  },
  markAsUnread(item) {
    // do not set property to null as the object may loose observer on that property
    // use Object.assign like this.
    item._userState = Object.assign(item._userState, { dateread: null });
    this.setUserdatemodified(item);
    localStorageUtil.addUserState(item);
  },
  isUnread(item) {
    return item._userState && !item._userState.dateread;
  },
  isRead(item) {
    return item._userState && !!item._userState.dateread;
  },
  setUserdatemodified(item) {
    let dateIsoString = new Date().toISOString();
    item._userState.userdatemodified = dateIsoString;
    return dateIsoString;
  },
};
